<template>
    <div class="pdf">
        <template v-for="(page, index) of configuration.data.pages">
            <div class="page oh">
                <img :src="page" />
            </div>
            <div class="flex flex-center page-number">
                <div class="badge">Page {{index + 1}}</div>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        name: 'PDF',
        props: {
            configuration: Object
        },
        computed: {

        }
    }
</script>

<style scoped lang="less">
    @import "~@/assets/less/variables";

    .page
    {
        max-width: 800px;
        border-radius: 6px;
        box-shadow: 0 4px 20px -2px rgba(0, 0, 0, 0.25);
        margin-top: 50px;

        img
        {
            width: 100%;
            object-fit: cover;
        }
    }
    @media print {
        .page {
              box-shadow: none !important;
        }
        .page-number {
            display: none !important;
        }
    }
    .page-number
    {
        max-width: 800px;
        margin: 30px 0 70px;
    }

    .badge
    {
        padding: 2px 8px;
        height: 22px;
        line-height: 18px;
        border-radius: 15px;
        font-size: 12px;
        font-weight: 600;
        white-space: nowrap;
        text-transform: uppercase;
        background: fade(@base, 20%);
        color: @base;
    }
</style>
